<footer class="w-full bg-neutral-gray-900 overflow-visible font-poppins" [ngClass]="loggedIn ? 'pt-32' : 'pt-[88px]'">
  <div *ngIf="loggedIn" class="w-full sm:w-[500px] sm:m-auto sm:items-center px-6">
    <!-- Bloque CTA -->
    <div class="flex flex-col gap-4 items-start mb-16 relative">
      <!-- Imagen decorativa maestro -->
      <div class="absolute -top-20 right-0 w-48 h-48 z-0 sm:-top-24">
        <img 
          src="assets/img/maestro-public.png" 
          alt="Maestro" 
          class="w-full h-full object-contain"
        />
      </div>

      <!-- Título -->
      <h2 class="block sm:hidden text-white text-xl font-poppins font-semibold leading-tight text-left mb-0 relative z-10">
        ¿Eres Maestro<br>de Obra?
      </h2>

       <h2 class="hidden sm:block text-white text-xl font-poppins font-semibold leading-tight text-left mb-0 relative z-10">
        ¿Eres Maestro de Obra?
      </h2>

      <!-- Botones -->
      <button
        (click)="goToRegister()"
        class="bg-cantera-red-primary text-white px-4 py-4 rounded-lg font-poppins font-bold text-base flex items-center gap-2 hover:bg-[#B71C1A] transition-colors w-full justify-center h-14 relative z-10"
      >
        <span>Unirme a Cantera</span>
        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="14" viewBox="0 0 16 14" fill="none">
  <path fill-rule="evenodd" clip-rule="evenodd" d="M8.17712e-08 6.85765C0.000179064 6.22671 0.511634 5.71522 1.14258 5.71507L12.0986 5.71507L8.33496 1.9514C7.88872 1.50508 7.88867 0.781477 8.33496 0.335187C8.78127 -0.110824 9.50495 -0.110966 9.95117 0.335187L15.665 6.05003C15.6918 6.07676 15.7172 6.10475 15.7412 6.13402C15.7788 6.17978 15.8105 6.22879 15.8398 6.27855C15.8481 6.29249 15.8566 6.30622 15.8643 6.32054C15.8723 6.33563 15.8794 6.35108 15.8867 6.36644C15.8957 6.38521 15.9051 6.40375 15.9131 6.42308C15.9213 6.44306 15.9285 6.4633 15.9355 6.48363C15.9399 6.49626 15.9443 6.50888 15.9482 6.52171C15.9576 6.55209 15.9659 6.58259 15.9727 6.61351C15.9739 6.61906 15.9754 6.62453 15.9766 6.63011C15.9995 6.74334 16.0058 6.85925 15.9941 6.97386C15.9937 6.97812 15.9927 6.98231 15.9922 6.98655C15.9842 7.05722 15.9694 7.12707 15.9482 7.19554C15.945 7.20609 15.9411 7.21637 15.9375 7.22679C15.9298 7.24937 15.9222 7.27201 15.9131 7.29417C15.9051 7.31348 15.8957 7.33205 15.8867 7.35081C15.8794 7.36602 15.8732 7.38177 15.8652 7.39671C15.8532 7.41916 15.8396 7.44062 15.8262 7.46214C15.8205 7.47117 15.8155 7.48058 15.8096 7.48948C15.7955 7.51067 15.7801 7.53084 15.7646 7.55101C15.7566 7.56151 15.7497 7.57295 15.7412 7.58323C15.7174 7.61228 15.6916 7.6397 15.665 7.66624L9.95117 13.3801C9.50486 13.8264 8.78127 13.8264 8.33496 13.3801C7.88865 12.9338 7.88865 12.2102 8.33496 11.7639L12.0977 8.0012L1.14258 8.0012C0.511524 8.00105 7.42455e-08 7.48874 8.17712e-08 6.85765Z" fill="white"/>
</svg>
      </button>

      <button
        (click)="goToOwner()"
        class="border-2 border-white text-white px-4 py-4 rounded-lg font-poppins font-bold text-base flex items-center gap-2 hover:bg-white hover:text-neutral-gray-900 transition-colors w-full justify-center h-14 relative z-10"
      >
        <span>¿Eres Propietario?</span>
        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="14" viewBox="0 0 16 14" fill="none">
  <path fill-rule="evenodd" clip-rule="evenodd" d="M8.17712e-08 6.85765C0.000179064 6.22671 0.511634 5.71522 1.14258 5.71507L12.0986 5.71507L8.33496 1.9514C7.88872 1.50508 7.88867 0.781477 8.33496 0.335187C8.78127 -0.110824 9.50495 -0.110966 9.95117 0.335187L15.665 6.05003C15.6918 6.07676 15.7172 6.10475 15.7412 6.13402C15.7788 6.17978 15.8105 6.22879 15.8398 6.27855C15.8481 6.29249 15.8566 6.30622 15.8643 6.32054C15.8723 6.33563 15.8794 6.35108 15.8867 6.36644C15.8957 6.38521 15.9051 6.40375 15.9131 6.42308C15.9213 6.44306 15.9285 6.4633 15.9355 6.48363C15.9399 6.49626 15.9443 6.50888 15.9482 6.52171C15.9576 6.55209 15.9659 6.58259 15.9727 6.61351C15.9739 6.61906 15.9754 6.62453 15.9766 6.63011C15.9995 6.74334 16.0058 6.85925 15.9941 6.97386C15.9937 6.97812 15.9927 6.98231 15.9922 6.98655C15.9842 7.05722 15.9694 7.12707 15.9482 7.19554C15.945 7.20609 15.9411 7.21637 15.9375 7.22679C15.9298 7.24937 15.9222 7.27201 15.9131 7.29417C15.9051 7.31348 15.8957 7.33205 15.8867 7.35081C15.8794 7.36602 15.8732 7.38177 15.8652 7.39671C15.8532 7.41916 15.8396 7.44062 15.8262 7.46214C15.8205 7.47117 15.8155 7.48058 15.8096 7.48948C15.7955 7.51067 15.7801 7.53084 15.7646 7.55101C15.7566 7.56151 15.7497 7.57295 15.7412 7.58323C15.7174 7.61228 15.6916 7.6397 15.665 7.66624L9.95117 13.3801C9.50486 13.8264 8.78127 13.8264 8.33496 13.3801C7.88865 12.9338 7.88865 12.2102 8.33496 11.7639L12.0977 8.0012L1.14258 8.0012C0.511524 8.00105 7.42455e-08 7.48874 8.17712e-08 6.85765Z" fill="white"/>
</svg>
      </button>
    </div>
  </div>

      <!-- Divisor -->
    <div *ngIf="loggedIn" class="h-0 w-full border-t-2 border-neutral-gray-800 mb-16"></div>

   <div class="w-full sm:m-auto sm:items-center px-6">
    <!-- Logo y copyright -->
    <div class="flex flex-col gap-2 items-center mb-16">
      <div class="w-full h-24 flex items-center justify-center">
        <img src="assets/icons/new-logo-header.svg" alt="CANTERA" class="h-[96px] w-full brightness-0 invert" />
      </div>

      <p class="text-neutral-gray-400 text-sm font-poppins font-normal text-center m-0">
        Todos los derechos reservados © 2026
      </p>
    </div>
  </div>

  <!-- Bloque Copyright con UNACEM -->
  <div class="bg-neutral-gray-300 w-full flex items-center justify-center h-16">
    <div class="flex items-center gap-3">
      <p class="text-neutral-gray-900 text-sm font-poppins font-medium m-0">
        Con el respaldo de
      </p>
      <img 
        src="assets/icons/unacem-footer.png" 
        alt="UNACEM" 
        class="h-7 w-auto"
        (error)="$event.target.src='assets/img/logo_construyo.png'"
      />
    </div>
  </div>
</footer>
